export default __webpack_public_path__ + "e159da1917e626667ed843c092d9992c.png";